module.exports = __webpack_public_path__ + "media/images/sit_to_stand-458a598b.png";